import styles from './LoggedInBanner.less';
import svgMarkup from '!!raw!svgo!./LoggedInBanner.svg';

import React, { Component } from 'react';
import ExternalLink from 'ExternalLink/ExternalLink';
import { ChevronIcon } from 'seek-style-guide/react';

const svgMarkupWithClassName = svgMarkup.replace('<svg ', `<svg class="${styles.imageSvg}" `);
const title = 'Read real reviews by real employees';

export default class LoggedInBanner extends Component {

  render() {
    /* eslint-disable react/no-danger */
    return (
      <div className={styles.root}>
        <p className={styles.title}>
          Find out about a company before you begin
        </p>
        <ExternalLink
          analytics="banner:companies"
          className={styles.container}
          title={title}
          aria-label={title}
          href="/companies/">
          <span className={styles.link}>
            <span className={styles.secondary}>Read </span>
            <span className={styles.primary}>r</span>eal reviews by real employees
          </span>
          <ChevronIcon className={styles.chevron} direction="right" svgClassName={styles.chevronSvg} />
          <span className={styles.image} dangerouslySetInnerHTML={{ __html: svgMarkupWithClassName }} />
        </ExternalLink>
      </div>
    );
    /* eslint-enable react/no-danger */
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/components/LoggedInBanner/LoggedInBanner.js
 **/